var productData = [];
var col1Product;
var col2Product;
var col3Product;
var col4Product;
var col5Product;
var currentPage;
var dataUrl;
var specsMode = false;
$(function () {
    /* Get the page id from the HTML tag */
    currentPage = document.documentElement.id;

    /* Load data based on the page being displayed */
    if(currentPage === "compare-cameras") {
        dataUrl = "/cameras/compare/cameraData.json";
    } else if(currentPage === "versax41-specs" || currentPage ==="versax22-specs" || currentPage === "versax120-specs") {
        dataUrl = "/cameras/compare/cameraData.json";
        specsMode = true;
    }

    /* Load Product data from file */
    $.getJSON(dataUrl, function(json) {
        productData = json;
        var parameters = null;

        if(!specsMode) {
            /* Get part of the URL starting with '?' */
            if(window.location.search.length > 0) {
                parameters = window.location.search;

                /* remove the '?products=' */
                parameters = parameters.split("?products=").pop();

                /* Create array and remove '&' */
                parameters = parameters.split("&");
            }

            if(parameters != null) {
                /* set the selects to the products in the url */
                for (var i=0; i < parameters.length; i++) {
                    var sel = document.getElementById("col"+(i+1)+"Product");
                    var opts = sel.querySelectorAll(".optionsWrapper .options li");
                    for (var j=0; j < opts.length; j++) {
                        if(opts[j].dataset.value == parameters[i]) {
                            selectItemCustomSelect(sel, opts[j]);
                            break;
                        }
                    }
                }
            }

            /* Gets the selected products */
            col1Product = parseInt(document.querySelector("#col1Product .selectedOption").dataset.value);
            col2Product = parseInt(document.querySelector("#col2Product .selectedOption").dataset.value);
            col3Product = parseInt(document.querySelector("#col3Product .selectedOption").dataset.value);
            col4Product = parseInt(document.querySelector("#col4Product .selectedOption").dataset.value);
            col5Product = parseInt(document.querySelector("#col5Product .selectedOption").dataset.value);
        }

        if(currentPage ==='versax41-specs') {
            col1Product = 693;
            col2Product = 695;
            col3Product = 696;
        } else if(currentPage === 'versax22-specs') {
            col1Product = 699;
            col2Product = 700;
        } else if(currentPage === 'versax120-specs') {
            col1Product = 701;
            col2Product = 702;
            col3Product = 703;
        }

        /* Sets product data based on select values */
        if(col1Product) { displayCompareCol(1, col1Product) };
        if(col2Product) { displayCompareCol(2, col2Product) };
        if(col3Product) { displayCompareCol(3, col3Product) };
        if(col4Product) { displayCompareCol(4, col4Product) };
        if(col5Product) { displayCompareCol(5, col5Product) };

        if(!specsMode) {
            /* Update URL */
            updateURL();
        }
    });
});

    function updateURL() {
        var urlStr = "?products=";
        urlStr += col1Product;
        urlStr += "&" + col2Product;
        urlStr += "&" + col3Product;
        urlStr += "&" + col4Product;
        urlStr += "&" + col5Product;

        history.replaceState(null, null, window.location.pathname + urlStr);
    }

    /* displays product details in the specified column  */
    function displayCompareCol(columnNumber, productId) {
        console.log('displayCompareCol called! columnNumber: '+columnNumber + ' productId: '+productId);
        if(!specsMode) {
            /* Update URL */
            window['col'+columnNumber+'Product'] = productId;
            updateURL();
        }

        if (productId === 0) {
            console.log("None selected");
        }

        /* Get Data for the correct product */
        var cData = getProductData(productId);

        /* Populate page with data */
        if(currentPage === "compare-cameras" || specsMode) {
            var optionalLensesLabel = "Optional Lenses";
            /* Determine if there are multiple optional lenses */
            if(cData.hasOwnProperty('optionalLenses') && cData.optionalLenses.indexOf('<br>') === -1){
                optionalLensesLabel = "Optional Lens"
            }

            displayProductDataHero(columnNumber, "https://deva90sapmc8w.cloudfront.net/" + cData.img, cData.productIndex, cData.url);
            if(specsMode) {
                displayProductDataName(columnNumber, cData.name);
            }
            displayProductDataWithLabel("rowResolution", columnNumber, cData.resolution, "Resolution", false, true);
            displayProductDataWithLabel("rowNativeFrameRate", columnNumber, cData.nativeFrameRate, "Native Frame Rate", false, true);
            displayProductDataWithLabel("rowLatency", columnNumber, cData.latency, "Latency", false, true);
            displayProductDataWithLabel("rowShutterDefaultSpeed", columnNumber, cData.shutterDefaultSpeed, "Default Speed", true, true);
            displayProductDataWithLabel("rowShutterMinSpeed", columnNumber, cData.shutterMinSpeed, "Minimum Speed", true, true);
            displayProductDataWithLabel("rowShutterMaxSpeed", columnNumber, cData.shutterMaxSpeed, "Maximum Speed", true, true);
            displayProductDataWithLabel("rowLedCount", columnNumber, cData.ledCount, cData.ledType, false, true);
            displayProductData("rowLedInfrared", columnNumber, cData.ledInfrared, true);
            displayProductData("rowDataPort", columnNumber, cData.dataPort, true);
            displayProductData("rowCameraSync", columnNumber, cData.cameraSync, true);
            displayProductData("rowPowerConnection", columnNumber, cData.powerConnection, true);
            displayProductData("rowAdjustableFocus", columnNumber, cData.adjustableFocus, true);
            displayProductData("rowFStop", columnNumber, cData.fStop, true);
            displayProductDataWithLabel("rowFilterSwitcher", columnNumber, cData.filterSwitcher, "Filter Switcher", true, true);
            displayProductDataWithLabel("rowStockLens", columnNumber, cData.stockLens, "Stock Lens", true, false);
            displayProductDataWithLabel("rowOptionalLenses", columnNumber, cData.optionalLenses, optionalLensesLabel, true, true);
            displayProductData("rowRawGrayscale", columnNumber, cData.rawGrayscale, true);
            displayProductData("rowObject", columnNumber, cData.object, true);
            displayProductData("rowMjpeg", columnNumber, cData.mjpeg, true);
            displayProductDataBoolean("rowMotiveDuplex", columnNumber, cData.motiveDuplex, 'Duplex Mode', true);
            displayProductDataBoolean("rowMotiveHQMJPEG", columnNumber, cData.motiveHQMJPEG, 'Prime<sup>x</sup> 120 Full Resolution MJPEG', true);
            displayProductData("rowMaterials", columnNumber, cData.materials, true);
            displayProductData("rowMount", columnNumber, cData.mount, true);
            displayProductData("rowStatusIndicator", columnNumber, cData.statusIndicator, true);
            displayProductData("rowHealthActivityIndicator", columnNumber, cData.healthActivityIndicator, true);

            displayProductDataWithLabel("rowWidth", columnNumber, cData.width, "Width", true, true);
            displayProductDataWithLabel("rowHeight", columnNumber, cData.height, "Height", true, true);
            displayProductDataWithLabel("rowDepth", columnNumber, cData.depth, "Depth", true, true);
            displayProductDataWithLabel("rowWeight", columnNumber, cData.weight, "Weight", true, true);

            displayProductDataWithLabel("rowPassiveRange", columnNumber, cData.passiveRange, "Passive Markers", true, true);
            displayProductDataWithLabel("rowActiveRange", columnNumber, cData.activeRange, "Active Markers", true, true);
            displayProductDataWithLabel("rowAccuracy", columnNumber, cData.accuracy, "3D Accuracy", true, true);
        }

    }

    /* Updates the hero section that appears at the top of each column */
    function displayProductDataHero(colId, img, productIndex, url) {

        /* set a class to target this product image */
        var productBox = $("#rowHero .col" + colId + " .productBox").removeClass();
        productBox.addClass("productBox product"+productIndex);
        productBox.attr('href', url);

        $("#rowHero .col" + colId + " .prodImg").attr('src', img);
        $("#rowHero .col" + colId + " .price").html(getProductPrice(productIndex));

    }

    function displayProductDataName(colId, name) {
        $("#rowName .col" + colId + " .cameraName").html(name);
    }

    /* gets the hidden product price pulled from the DB */
    function getProductPrice(productIndex) {
        if($("#product"+productIndex).length) {
            return $("#product"+productIndex).html();
        }else {
            return "";
        }
    }

    /* Updates a single piece of data */
    function displayProductData(rowId, colId, newData, required) {

        if(newData === null || newData ==="" && required === true) {
            $("#" + rowId + " .col" + colId).html("<div class='noCompareData'><div class='dash'></div></div>");
        } else {
            $("#" + rowId + " .col" + colId).html(newData);
        }
    }

    /* Updates a single piece of data */
    function displayProductDataBoolean(rowId, colId, newData, label, required) {

        if(newData === null || newData === false || newData ==="" && required === true) {
            $("#" + rowId + " .col" + colId).html("<div class='noCompareData'><div class='dash'></div></div>");
        } else {
            $("#" + rowId + " .col" + colId).html(label);
        }
    }

    /* Updates a single piece of data that has a label */
    function displayProductDataWithLabel(rowId, colId, newData, label, labelOnTop, required) {

        if(newData === null || newData ==="" && required === true) {
            $("#" + rowId + " .col" + colId).html("<div class='noCompareData'><div class='dash'></div></div>");
        } else {
            if(labelOnTop) {
                $("#" + rowId + " .col" + colId).html("<div class='label'></div><div class='value'></div>");
            } else {
                $("#" + rowId + " .col" + colId).html("<div class='value'></div><div class='label'></div>");
            }
            $("#" + rowId + " .col" + colId + " .value").html(newData);
            $("#" + rowId + " .col" + colId + " .label").html(label);

            /* Hide label if no data */
            if(newData === null || newData === "") {
                $("#" + rowId + " .col" + colId + " .label").hide();
            } else {
                $("#" + rowId + " .col" + colId + " .label").show();
            }
        }
    }

    /* Updates a value and label from data */
    function displayProductDataAndLabel(rowId, colId, newData, newLabel, required) {

        if(newData === null || newData ==="" && required === true) {
            $("#" + rowId + " .col" + colId).html("<div class='noCompareData'><div class='dash'></div></div>");
        } else {
            $("#" + rowId + " .col" + colId).html("<div class='value'></div><div class='label'></div>");
            $("#" + rowId + " .col" + colId + " .value").html(newData);
            $("#" + rowId + " .col" + colId + " .label").html(newLabel);

            /* Hide label if no data */
            if(newData === null || newData === "") {
                $("#" + rowId + " .col" + colId + " .label").hide();

            } else {
                $("#" + rowId + " .col" + colId + " .label").show();
            }
        }
    }

    /* Returns single product data from productData array */
    function getProductData(productId) {
        for(var i=0; i < productData.length; i++) {
            if(productData[i].productIndex === productId) {
                return productData[i];
            }
        }
        return null;
    }

/* Allows forEach in IE11 */
if(window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}
if(window.HTMLCollection && !HTMLCollection.prototype.forEach) {
    HTMLCollection.prototype.forEach = Array.prototype.forEach;
}

var customSelects = document.querySelectorAll(".customSelect");

/* initialize each custom select */
customSelects.forEach(function (customSelect) {

    var buttons = customSelect.querySelectorAll(".buttonWrapper button");
    var colId = customSelect.id.replace("col","");
    colId = colId.replace("Product","");
    colId = parseInt(colId);
    buttons.forEach(function (button) {
        button.addEventListener('click', function() {
            toggleCustomSelect(customSelect);
        });
    });

    var optionList = customSelect.querySelectorAll('.optionsWrapper .options li');
    optionList.forEach(function (option) {
        option.addEventListener('click', function() {
            selectItemCustomSelect(customSelect, option);

            displayCompareCol(colId, parseInt(customSelect.querySelector(".buttonWrapper .selectedOption").dataset.value));
        });
    });
});

/* Opens/Closes custom select menu */
function toggleCustomSelect(customSelect) {
    customSelect.classList.toggle("open");
}

/* selects an item from the custom select menu */
function selectItemCustomSelect(customSelect, item) {
    /* Reference to the currently selected item */
    var selectedOption = customSelect.querySelector(".buttonWrapper .selectedOption");

    /* Get the new selection data-value */
    var liValue = item.dataset.value;
    /* Get the new selection html */
    var liHTML = item.innerHTML;

    /* Update the currently selected item with the new values */
    selectedOption.innerHTML = liHTML;
    selectedOption.dataset.value = liValue;

    /* Hide the selected option in the menu */
    var optionList = customSelect.querySelectorAll(".optionsWrapper .options li");

    /* Display all options */
    optionList.forEach(function (option) {
        option.style.display="block"
    });

    /* Hide the option that is currently selected */
    item.style.display="none";

    /* Hide the menu */
    customSelect.classList.remove("open");
}

/* Closes the custom select when click outside */
$(document).on("click", function(event){
    var $trigger = $(".customSelect");
    if($trigger !== event.target && !$trigger.has(event.target).length){
        $trigger.removeClass("open");
    }
});

